import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Axios from "../comp/Utils/axios";
import SummaryAPI from "../comp/Commson/summaryApi";
import { AxiosToastError } from "../comp/Utils/AxiosToastError";

const OtpVerificationPage = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputRefs = useRef([]);
  const location = useLocation()

  console.log("loction" , location)

//   if email is not present user redirect to forgotpasswordpage 


    useEffect(()=>{
        if(!location?.state?.email){
            navigate("/forgot-password")
        }
    })

  // handle input change
  const handleChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Auto-focus next box
      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  // handle backspace navigation
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // validation
  const validate = () => {
    if (otp.join("").length !== 6) {
      toast.error("Enter all 6 digits of OTP");
      return false;
    }
    return true;
  };

  // handle verify OTP
const handleVerifyOtp = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  try {
    const response = await Axios({
      url: SummaryAPI.otp_verification.url,
      method: SummaryAPI.otp_verification.method,
      data: { 
        otp: otp.join(""),
        email: location?.state?.email, 
      },
      headers: { "Content-Type": "application/json" },
    });

    if (response?.data?.success) {
      toast.success("OTP Verified ✅");
      setOtp(new Array(6).fill(""));

      navigate("/reset-password", {
        state: {
          data: response.data,
          email: location?.state?.email,
        },
      });
    } else {
      toast.error(response?.data?.message || "Invalid OTP");
    }
  } catch (error) {
    AxiosToastError(error);
  }
};


  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-indigo-500 to-purple-600 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-800 text-center">
          OTP Verification
        </h2>
        <p className="text-gray-500 text-center text-sm mt-2">
          Enter the 6-digit OTP sent to your email
        </p>

        <form onSubmit={handleVerifyOtp} className="mt-6 space-y-6">
          {/* OTP Boxes */}
          <div className="flex justify-center space-x-3">
            {otp.map((digit, index) => (
              <input
                key={index}
                ref={(el) => (inputRefs.current[index] = el)}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                className="w-12 h-12 text-center text-xl border rounded-lg focus:ring-2 focus:ring-indigo-400 focus:outline-none"
              />
            ))}
          </div>

          {/* Button */}
          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-2 rounded-lg font-medium transition-all"
          >
            Verify OTP
          </button>
        </form>

        <p className="text-sm text-center text-gray-600 mt-6">
          Didn’t get OTP?{" "}
          <span
            onClick={() => navigate("/forgot-password")}
            className="text-indigo-500 font-medium cursor-pointer hover:underline"
          >
            Resend
          </span>
        </p>
      </div>
    </div>
  );
};

export default OtpVerificationPage;
